import { Component, OnInit } from '@angular/core';
import { ComponentBase } from '../../../_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../_infrastructure/classes/services/auth.service';
import { NotificationService } from '../../../_infrastructure/classes/services/notification.service';
import { AsyncInfoRequestViewModel } from '../asyncInfo.types';

@Component({
    selector: 'app-async-infopopup',
    templateUrl: './asyncInfoPopup.component.html',
})
export class AsyncInfoPopupComponent extends ComponentBase implements OnInit {
    displayModal: boolean = false;

    asyncInfoRequestCollection: AsyncInfoRequestViewModel[];

    constructor(
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificationService, exceptionHandler);
    }

    ngOnInit() {
        this.asyncInfoRequestCollection = new Array<AsyncInfoRequestViewModel>();
    }

    aceptDialog() {
        this.displayModal = false;

        //this.selectedEmitter.emit(this.selectedCodigoEppoNombreCientifico!);
    }

    cancelDialog() {
        this.displayModal = false;
    }

    public showDialog(asyncInfoRequestCollection: AsyncInfoRequestViewModel[]) {
        this.displayModal = true;

        this.asyncInfoRequestCollection = asyncInfoRequestCollection;
    }
}
